export const ECONOMY_URL = 'https://vikqkqwklbdjfhkydzpw.supabase.co';
export const ECONOMY_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZpa3FrcXdrbGJkamZoa3lkenB3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYwNjYzODcsImV4cCI6MjA4MTY0MjM4N30.PPIf98mu1HgR95CaymSJiV9E5hnlsMJuQeXw2MNqKsw';
export const ECONOMY_AUTH_KEY = 'sb-vikqkqwklbdjfhkydzpw-auth-token';
